import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Terms from 'features/terms/Terms'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { Language } from 'types/language'
import TermsDutch from 'features/terms/content/TermsDutch'
import TermsFrench from 'features/terms/content/TermsFrench'
import classNames from 'classnames'
import styles from 'features/terms/Terms.module.scss'
import { Heading, Header } from '@boltenergy-be/design-system'
import Link from 'next/link'
import { routes } from 'utils/routes'
import dayjs from 'dayjs'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { useTranslation } from 'next-i18next/pages'
import { SORTED_OLD_TERMS_KEYS } from 'features/terms/Terms.constants'
import { SeoProps } from 'components/seo/types'

const TermsPage = () => {
  // i18n
  const { t } = useTranslation(['common', 'footer', 'terms'])
  const language = useGetLanguage()

  // Constants
  const seo: SeoProps = {
    title: t('terms:seo.title', { context: 'current' }),
    description: t('terms:seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <Header title={t('footer:termsAndConditions')} color="accent-soft" docked shape="s4" />

      <Terms
        content={{
          [Language.DUTCH]: <TermsDutch />,
          [Language.FRENCH]: <TermsFrench />
        }}
      />

      <section className={classNames(styles.terms, styles['old-versions'])}>
        <Heading as="h2" variant="h3">
          {t('terms.oldVersions.title', 'Oude Algemene Voorwaarden')}
        </Heading>

        <ul>
          {SORTED_OLD_TERMS_KEYS.map((version) => (
            <li key={version}>
              <Link href={routes(language, version).oldTerms}>
                {t('terms.oldVersions.version', 'Geldig tot {{ version }}', { version: dayjs(version).format('DD/MM/YYYY') })}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'terms'], i18nConfig))
    }
  }
}

export default TermsPage
